import React from 'react';
import { CoreGoogleAnalyticsSettings, CoreEnv } from '@eb/context-gen';

interface KeyedCoreEnv {
    env: CoreEnv;
}

export interface FacebookOptions {
    appId: string;
    version: string;
    xfbml: boolean;
}

interface KeyedFacebookOptions {
    facebookOptions: FacebookOptions;
}

interface Captcha {
    captchaKey: string;
}

export const EnvContext = React.createContext<
    Partial<
        CoreGoogleAnalyticsSettings &
            KeyedCoreEnv &
            KeyedFacebookOptions &
            Captcha
    >
>({});
